import { useState } from 'react';
import { cn } from '../../lib/utils';

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
  priority?: boolean;
  width?: number | string;
  height?: number | string;
}

export const OptimizedImage = ({
  src,
  alt,
  className,
  priority = false,
  width,
  height,
  ...props
}: OptimizedImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      loading={priority ? 'eager' : 'lazy'}
      decoding={priority ? 'sync' : 'async'}
      // @ts-ignore - fetchpriority is valid HTML attribute
      fetchpriority={priority ? 'high' : 'auto'}
      width={width}
      height={height}
      className={cn(
        "transition-opacity duration-300 ease-in-out",
        isLoaded ? "opacity-100" : "opacity-0",
        hasError && "hidden",
        className
      )}
      onLoad={() => setIsLoaded(true)}
      onError={() => setHasError(true)}
      {...props}
    />
  );
};
